/** Waveform peaks: one byte per column, the largest |sample| in that slice scaled to 0..255. */
export const PEAK_COUNT = 2000;
export const MIN_PEAK_COUNT = 16;
export const PEAKS_CONTENT_TYPE = "application/octet-stream";

/** Thumbnails: WebP, longest edge at most THUMB_EDGE pixels. */
export const THUMB_EDGE = 512;
export const THUMB_CONTENT_TYPE = "image/webp";
export const MAX_THUMB_BYTES = 256 * 1024;

export const MAX_DURATION_MS = 7 * 24 * 60 * 60 * 1000;

export const isPeaksLength = (bytes: number): boolean =>
  Number.isInteger(bytes) && bytes >= MIN_PEAK_COUNT && bytes <= PEAK_COUNT;
